import http from "@/helper/http";
import {useQuery} from "@tanstack/react-query";
import {BaseVO} from "@/model/global";

export enum AnalyzeEnum {
    GetAddCustomerTrend = "/client/addCustomerTrend",
    GetAddProductTrend = "/client/addProductTrend",
    GetGatherPayback = "/finance/gatherPayback",
    GetGatherInvoice = "/finance/gatherInvoice",
    GetCustomerYearCompare = "/client/yearCompare",
    GetGatherWriting = "/mission/gatherWriting",
    GetGatherProduct = "/mission/gatherProduct",
    GetGatherWriterTime = "/mission/gatherWriterTime",
}

export interface XYVO {
    [key: string]: any;

    x: string;
    y: number;
}

export interface AddCustomerTrendVO {
    dealsCreator: XYVO[];
    dealsTrend: XYVO[];
    leadsCreator: XYVO[];
    leadsTrend: XYVO[];
    recent7MonthChances: XYVO[];
    recentYearCustomers: XYVO[];
}

export interface AddProductTrendVO {
    copyrights: XYVO[];
    creators: XYVO[];
    patents: XYVO[];
    projects: XYVO[];
    trademarks: XYVO[];
}

export interface CustomerYearCompareVO {
    contracts: XYVO[];
    copyrightDist: XYVO[];
    customerDist: XYVO[];
    customers: XYVO[];
    patentDist: XYVO[];
    projectDist: XYVO[];
    trademarkDist: XYVO[];
}

export interface GatherPaybackVO {
    areaPaybackRanking: XYVO[];
    intervalPayback: XYVO[];
    lastYearPaybacks: XYVO[];
    paymentMethods: XYVO[];
    quarterPaybacks: XYVO[];
    receiveMethods: XYVO[];
    recent1YearPayment: XYVO[];
    recentYearPaybacks: XYVO[];
    sellerMonthRanking: XYVO[];
    sellerYearRanking: XYVO[];
    thisYearPaybacks: XYVO[];
}

export interface GatherInvoiceVO {
    invoiceTypes: XYVO[]
    invoiceCompanies: XYVO[]
    recent1YearMoney: XYVO[]
}

export interface GatherWritingVO {
    writeCopyrightStatus: XYVO[]
    writePatentStatus: XYVO[]
    writeProjectStatus: XYVO[]
    writeTrademarkStatus: XYVO[]
    writerCopyrightStatus: XYVO[]
    writerPatentStatus: XYVO[]
    writerProjectStatus: XYVO[]
    writerTrademarkStatus: XYVO[]
}

export interface GatherProductVO {
    copyrightTrend: XYVO[];
    patentTrend: XYVO[];
    productRanks: XYVO[];
    projectTrend: XYVO[];
    scatterTrademarks: XYVO[];
    top5CopyrightWriter: XYVO[];
    top5PatentWriter: XYVO[];
    top5ProjectWriter: XYVO[];
    top5TrademarkWriter: XYVO[];
    top10PatentClas: XYVO[];
    top10ProjectClas: XYVO[];
    top10TrademarkClas: XYVO[];
    top10CopyrightClas: XYVO[];
    trademarkTrend: XYVO[];
}

export interface GatherWriterTimeVO {
    recent12AssignCopyrightTime: XYVO[]
    recent12AssignPatentTime: XYVO[]
    recent12AssignProjectTime: XYVO[]
    recent12AssignTrademarkTime: XYVO[]
    recent12FinishCopyrightTime: XYVO[]
    recent12FinishPatentTime: XYVO[]
    recent12FinishProjectTime: XYVO[]
    recent12FinishTrademarkTime: XYVO[]
    recent12ReceiveCopyrightTime: XYVO[]
    recent12ReceivePatentTime: XYVO[]
    recent12ReceiveProjectTime: XYVO[]
    recent12ReceiveTrademarkTime: XYVO[]
}

export const useQueryAddCustomerTrend = () => useQuery({
    queryKey: ['AddCustomerTrend'],
    queryFn: () => http.get<BaseVO<AddCustomerTrendVO>>({url: AnalyzeEnum.GetAddCustomerTrend})
});


export const useQueryAddProductTrend = () => useQuery({
    queryKey: ['addProductTrend'],
    queryFn: () => http.get<BaseVO<AddProductTrendVO>>({url: AnalyzeEnum.GetAddProductTrend})
});

export const useQueryGatherPayback = () => useQuery({
    queryKey: ['gatherPayback'],
    queryFn: () => http.get<BaseVO<GatherPaybackVO>>({url: AnalyzeEnum.GetGatherPayback})
});

export const useQueryGatherInvoice = () => useQuery({
    queryKey: ['gatherInvoice'],
    queryFn: () => http.get<BaseVO<GatherInvoiceVO>>({url: AnalyzeEnum.GetGatherInvoice})
});

export const useQueryCustomerYearCompare = () => useQuery({
    queryKey: ['customerYearCompare'],
    queryFn: () => http.get<BaseVO<CustomerYearCompareVO>>({url: AnalyzeEnum.GetCustomerYearCompare})
});

export const useQueryGatherWriting = () => useQuery({
    queryKey: ['gatherWriting'],
    queryFn: () => http.get<BaseVO<GatherWritingVO>>({url: AnalyzeEnum.GetGatherWriting})
});

export const useQueryGatherWriterTime = () => useQuery({
    queryKey: ['gatherWriterTime'],
    queryFn: () => http.get<BaseVO<GatherWriterTimeVO>>({url: AnalyzeEnum.GetGatherWriterTime})
});

export const useQueryGatherProduct = () => useQuery({
    queryKey: ['gatherProduct'],
    queryFn: () => http.get<BaseVO<GatherProductVO>>({url: AnalyzeEnum.GetGatherProduct})
});



